import {
  CollectFormsQuery,
  CollectFormTypeEnum,
  StandardEnum,
} from '@/graphql/generated';
import { CollectFormsResponse } from '@/slices/indicators/indicators.types';

const collectFormTypeValues = new Set(Object.values(CollectFormTypeEnum));

export const normalizeCollectFormsResponse = (
  response: CollectFormsResponse,
): CollectFormsQuery => {
  return {
    collectFormViews: {
      pageInfo: {
        hasNextPage: response.collectForms.pageInfo.hasNextPage,
        hasPreviousPage: response.collectForms.pageInfo.hasPreviousPage,
        total: response.collectForms.pageInfo.total,
        page: response.collectForms.pageInfo.page,
        pageCount: response.collectForms.pageInfo.pageCount,
      },
      nodes: response.collectForms.nodes.map((node) => {
        const type = collectFormTypeValues.has(node.type as CollectFormTypeEnum)
          ? (node.type as CollectFormTypeEnum)
          : CollectFormTypeEnum.CustomIndicator;

        return {
          relatedEntityId: node.relatedEntityId,
          relatedEntityTranslation: (node.relatedEntityTranslation ?? []).map(
            (translation) => ({
              language: translation.language,
              name: translation.name,
            }),
          ),
          type,
          enterpriseId: node.enterpriseId,
          reportStandards: (node.reportStandards ?? []).filter(
            (reportStandards) =>
              Object.values(StandardEnum).includes(
                reportStandards as StandardEnum,
              ),
          ) as StandardEnum[],
        };
      }),
    },
  };
};
